import React from "react";
import "./PageNotFound.css";
import Particle from "./Particle";
import sad from "./sad.png";
import { Helmet } from "react-helmet";

const PageNotFound = (props) => {
  return (
    <div>
      <Helmet>
        <title> 404 Not Found || {window.location.hostname}</title>

        <link rel="canonical" href="https://resume-search.com/login/" />
      </Helmet>
      <Particle className="particle_display" />
      <div className="maindiv">
        <img className="imagehieght" src={sad} alt="" />
        <p className="mainhead">Oops, looks like the page is lost.</p>
        <p className="mainhead1">
          This is not a fault, just an accident that was not intentional.
        </p>
        <div
          className="designbutton"
          onClick={() => {
            props.navigate("/");
          }}
        >
          <button className="designbutton">Go to Home</button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
